import _ from 'lodash';
import moment from 'moment';

function generateImagesWithMetaPayload({
    images,
    tag = 'unclassified',
    namePrefix = 'Unclassified',
}) {
    return _.reduce(
        images,
        (result, image, idx) => {
            result.push({
                image,
                meta: {
                    title: `${namePrefix}(${idx + 1}): ${moment().format('YYYY-MM-DD h:mm:ss a')}`,
                    tag,
                },
            });
            return result;
        },
        []
    );
}

// eslint-disable-next-line import/prefer-default-export
export const lsImageHelpers = {
    generateImagesWithMetaPayload,
};
